<template>
  <div class="springter-section-1 springter-section">
    <lang-menu></lang-menu>
    <!-- TODO add poster -->
    <video muted autoplay loop playsinline>
        <source src="../assets/media/SPRINGTER _VIDEO_FOTOS_SIN TEXTOS_1280x720_FINAL.mp4" type="video/mp4"  media="all and (max-width: 1200px)">
        <source src="../assets/media/SPRINGTER _VIDEO_FOTOS_SIN TEXTOS_1920x1080_FINAL.mp4" type="video/mp4">
    </video>
    <div class="springter-section__logo">
        <img src="../assets/img/Springter_Logo_Color_RGB-21.svg" alt="Logo Springter" />
    </div>
    <arrow-button direction="down" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 1})"></arrow-button>
  </div>
</template>

<script>

import LangMenu from './shared/LangMenu';
import ArrowButton from './shared/ArrowButton';

export default {
  name: 'springter-section-1',
  components: {
    LangMenu,
    ArrowButton,
  },
};
</script>

<style lang="scss" scoped>

    .springter-section{
        
        &__logo{
            position: absolute;
            z-index: 1;
            left: 33%;
            top: 42%;
            width: 34%;

        }
    }

    button.arrow{
      position: absolute;
      left: 50%;
      margin-left: -17px;
    }

    video { 
        position: fixed;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        z-index: -100;
        transform: translateX(-50%) translateY(-50%);
        background: url('../assets/img/poster.jpg') no-repeat;
        background-size: cover;
        transition: 1s opacity;
    }
    .stopfade { 
    opacity: .5;
    }

.springter-section__logo{
  @include mq('phablet', 'max') {
    left: 5%;
    top: 40%;
    width: 90%;
  }

  @include mqlandscape(){
    left: 5%;
    top: 40%;
    width: 90%;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/SpringterSection1.vue